import { render, staticRenderFns } from "./SatsangiProfileList.vue?vue&type=template&id=45e3c23e&lang=html&"
import script from "./SatsangiProfileList.vue?vue&type=script&lang=js&"
export * from "./SatsangiProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports